import { ACTIVE_BOOKING_URL } from "../config/bookingLinks.js";

export const GROUP_REGISTRATION_PATH = ACTIVE_BOOKING_URL;

const sharedEnrollment = {
  frequency: "Weekly",
  sessionLength: "60 minutes",
  programLength: "6 weeks",
  startTiming: "Beginning late September 2026",
  format: "In-person",
  location: {
    name: "Perspective Therapy",
    street: "4 Gilder Street, Suite 2",
    city: "Larchmont, NY 10538",
  },
  price: "$850 total for the full 6-week cohort",
  paymentPositioning:
    "Perspective Therapy is a private-pay and out-of-network practice.",
  screening:
    "A 30-minute virtual caregiver intake and group-fit screening is required before placement is confirmed.",
  placement: [
    "Group therapy works best when children are thoughtfully matched.",
    "Registration does not guarantee final placement.",
    "Placement is confirmed after the caregiver intake and group-fit screening.",
  ],
  enrollmentRequirements: [
    "Registration begins the enrollment process.",
    "Enrollment is for the full six-week cohort.",
  ],
  enrollmentIncludes: [
    "30-minute virtual caregiver intake and group-fit screening",
    "Six weekly 60-minute in-person group psychotherapy sessions",
    "Caregiver guidance and practical takeaways",
    "End-of-cohort caregiver wrap-up with individualized recommendations",
  ],
  registrationStatus: "Open for Fall 2026 registration",
  registrationPath: GROUP_REGISTRATION_PATH,
};

export const currentGroupOfferings = [
  {
    ...sharedEnrollment,
    id: "big-feelings-calm-bodies",
    name: "Big Feelings & Calm Bodies",
    subtitle: "An Emotional Regulation Play Group",
    population: "Children",
    ageRange: "Ages 6–7",
    facilitators: ["Jeika Matthew", "Maddie Lula"],
    clinicalFocus:
      "Play-based emotional regulation support for young children.",
    fit: [
      "Worry or anxiety around school",
      "Big after-school emotions or meltdowns",
      "Sensory or emotional overwhelm",
      "Difficulty identifying or expressing feelings",
      "Stress that sometimes shows up physically, such as stomachaches or headaches",
      "Difficulty calming their bodies after becoming upset",
    ],
    skills: [
      "Recognizing emotions and body signals",
      "Expressing difficult feelings safely",
      "Identifying what helps their bodies feel calmer",
      "Coping with frustration and overwhelm",
      "Building flexibility and emotional confidence",
      "Age-appropriate regulation strategies",
    ],
    meetingDay: "Wednesdays",
    meetingTime: "4:00 PM–5:00 PM",
  },
  {
    ...sharedEnrollment,
    id: "friendship-flexibility-play",
    name: "Friendship, Flexibility & Play",
    subtitle: "A Peer Relationships & Social Skills Group",
    population: "Children",
    ageRange: "Ages 6–7",
    facilitators: ["Jeika Matthew", "Neyla Sassi"],
    clinicalFocus:
      "Play-based peer relationship and social-skills support for young children.",
    fit: [
      "Shyness or anxiety with peers",
      "Difficulty joining or staying engaged in play",
      "Challenges with taking turns or sharing control",
      "Frustration when play does not go as expected",
      "Difficulty navigating disagreements",
      "Trouble communicating feelings, wants, or needs with other children",
    ],
    skills: [
      "Joining and maintaining cooperative play",
      "Taking turns and sharing ideas",
      "Navigating disagreements and repairing after conflict",
      "Expressing wants, needs, and feelings",
      "Perspective-taking",
      "Flexibility when plans change",
      "Building confidence in peer relationships",
    ],
    meetingDay: "Saturdays",
    meetingTime: "10:00 AM–11:00 AM",
  },
];
